import SoundEngine from './SoundEngine';

export default class Click extends SoundEngine {
  play () {
    const verb = this.fx.verb(0.2);

    const aOsc = this.osc.square();
    const aGain = this.fx.gain();
    const aFilter = this.fx.filter();

    const aLength = 0.05;
    aOsc.frequency.setValueAtTime(220, this.now);
    aGain.gain.setValueAtTime(0, this.now);
    aGain.gain.exponentialRampToValueAtTime(0.35, this.now + (aLength - aLength + 0.01));
    aGain.gain.exponentialRampToValueAtTime(0.01, this.now + aLength);

    aOsc.connect(aGain);
    aGain.connect(aFilter);
    aFilter.connect(this.output);
    aFilter.connect(verb);

    const verbGain = this.fx.gain();
    verbGain.gain.setValueAtTime(0.5, this.now);
    verb.connect(verbGain);
    verbGain.connect(this.output);

    aOsc.start(this.now);
    aOsc.stop(this.now + aLength);
  }
}
